'use client';

import {
    ThemeProvider as NextThemesProvider,
    type ThemeProviderProps as NextThemesProviderProps,
} from 'next-themes';

export function ThemeProvider({ children, ...props }: NextThemesProviderProps) {
    return (
        <NextThemesProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            {...props}
        >
            {children}
        </NextThemesProvider>
    );
}
